module.exports = __webpack_public_path__ + "static/media/opinion.3a5f25e4.jpg";